import React, { useEffect, useState } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { BASE_URL1 } from './Constants';
import { Spinner } from 'react-bootstrap';
import { CSVLink } from 'react-csv';

const ManageBackendPayments = () => {
  const [payments, setPayments] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const perPage = 10;

  const fetchPayments = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${BASE_URL1}api/manage_backend`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await res.json();
      if (result.status) {
        setPayments(result.data);
        setFiltered(result.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  useEffect(() => {
    const lowerSearch = search.toLowerCase();
    setFiltered(
      payments.filter(
        (item) =>
          item.emp_name.toLowerCase().includes(lowerSearch) ||
          item.emp_id.toString().includes(lowerSearch) ||
          item.utr_number.toLowerCase().includes(lowerSearch) ||
          item.remarks.toLowerCase().includes(lowerSearch)
      )
    );
    setPage(1);
  }, [search, payments]);

  const paginated = filtered.slice((page - 1) * perPage, page * perPage);
  const totalPages = Math.ceil(filtered.length / perPage);

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen((prev) => !prev);
    }
  };

  return (
    <div className="page-wrapper bg-light">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />

        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="card shadow border-0">
                <div className="card-header bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                  <h5 className="mb-0 text-uppercase">Manage Payment Updates</h5>
                  <div className="d-flex" style={{ gap: '3px' }}>
                    <CSVLink
                      data={filtered}
                      filename={'payment_updates.csv'}
                      className="btn btn-sm btn-light"
                      style={{ marginRight: '12px' }}
                    >
                      Export to Excel
                    </CSVLink>

                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => window.location.href = "/backend_payment_update"}
                    >
                      <i className="fas fa-plus me-1"></i> Add
                    </button>
                  </div>

                </div>
                <div className="card-body">
                  <div className="mb-3 row">
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by ID, Name, UTR, Remarks..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>

                  {loading ? (
                    <div className="text-center my-5">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-hover table-bordered text-center align-middle">
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th>Emp ID</th>
                            <th>Emp Name</th>
                            <th>UTR Number</th>
                            <th>Remarks</th>
                            <th>Image</th>
                            <th>Created On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginated.length === 0 ? (
                            <tr>
                              <td colSpan="7">No records found</td>
                            </tr>
                          ) : (
                            paginated.map((item, index) => (
                              <tr key={item.id}>
                                <td>{(page - 1) * perPage + index + 1}</td>
                                <td>{item.emp_id}</td>
                                <td>{item.emp_name}</td>
                                <td>{item.utr_number}</td>
                                <td>{item.remarks}</td>

                                <td>
                                  {item.image ? (
                                    (() => {
                                      const fileExtension = item.image.split('.').pop().toLowerCase();
                                      const fileUrl = `${BASE_URL1}public/uploads/payment_images/${item.image}`;

                                      if (fileExtension === 'pdf') {
                                        return (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer">

                                            <i class="fa fa-file-pdf-o"></i>
                                          </a>
                                        );
                                      } else {
                                        return (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                            <img
                                              src={fileUrl}
                                              alt="GNR"
                                              style={{ height: '40px', borderRadius: '4px' }}
                                            />
                                          </a>
                                        );
                                      }
                                    })()
                                  ) : (
                                    'No Image'
                                  )}
                                </td>











                                <td>{item.created_on}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Page {page} of {totalPages}
                    </div>
                    <div>
                      <button
                        className="btn btn-outline-secondary btn-sm me-2"
                        disabled={page === 1}
                        onClick={() => setPage((prev) => prev - 1)}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={page === totalPages}
                        onClick={() => setPage((prev) => prev + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5"></div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ManageBackendPayments;
